import React, { useEffect, useState } from "react";
import api from '../../services/api';
import { useParams, useNavigate } from "react-router-dom";
import ComplainForm from "../../components/ComplainForm";

const EditComplain = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [complain, setComplain] = useState(null);
  const [applicant, setApplicant] = useState(null);
  
  useEffect(() => {
    const fetchComplainAndApplicant = async () => {
      try {
        // First fetch complain data
        const complainResponse = await api.get(`/Complains/${id}`);
        setComplain(complainResponse.data);
  
        // Then fetch applicant data using the applicantID from complain
        if (complainResponse.data.applicantID) {
          const applicantResponse = await api.get(`/applicants/${complainResponse.data.applicantID}`);
          setApplicant(applicantResponse.data);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
  
    fetchComplainAndApplicant();
  }, [id]);


  const handleSubmit = async (data) => {
    try {
      await api.put(`/Complains/${id}`, data);
      navigate("/complains/complainlist");
    } catch (error) {
      console.error("Error updating complain:", error);
    }
  };

  return (
    <div className="container mx-auto p-1">
      {complain && applicant ? <ComplainForm onSubmit={handleSubmit} defaultValues={complain} applicant={applicant} /> : <p>Loading...</p>}
    </div>
  );
};

export default EditComplain;